import { gql, InMemoryCache } from '@apollo/client';
import introspectionQueryResultData from '@generated/fragmentTypes.json';
import { overwriteMerger } from './mergers/common/overwriteMerger';

const localStateQuery = gql`
  query {
    toasts {
      message
    }
  }
`;

class ApolloCache extends InMemoryCache {
  async populate() {
    this.writeQuery({
      query: localStateQuery,
      data: {
        toasts: [],
      },
    });
  }
}

export const cache = new ApolloCache({
  addTypename: true,
  possibleTypes: introspectionQueryResultData.possibleTypes,
  typePolicies: {
    Query: {
      fields: {
        toasts: {
          merge: overwriteMerger,
        },
      },
    },
    User: {
      keyFields: ['id'],
    },
    Organisation: {
      keyFields: ['id'],
    },
    Dashboard: {
      keyFields: ['id'],
      fields: {
        items: {
          merge(existing = [], incoming: any[]) {
            return [...existing, ...incoming];
          },
        },
      },
    },
    BatchActivity: {
      keyFields: ['batchId', 'location', 'enteredAt'],
    },
    BatchPhase: {
      keyFields: ['id', 'activities'],
    },
    Asset: {
      keyFields: ['id'],
    },
    AssetWithModel: {
      keyFields: ['id'],
    },
    Model: {
      keyFields: ['urn'],
    },
    BatchInfo: {
      keyFields: ['id', 'hasMissingMetricDefinitions'],
    },
  },
});
